export default __webpack_public_path__ + "static/media/linkedin.b1213edb.svg";